import { setTheme } from "theme/default/setTheme";

export const setBackgroundColor_b7c8dc = setTheme(({ theme }) => `background-color: ${theme.colors.color_b7c8dc}`);
